import React from 'react';
import styles from './time-report-grid.module.scss';
import classNames from 'classnames';

interface Props {
    title: string;
    clientName?: string;
    workHours: number;
    plannedHours?: number;
    showPlannedHours?: boolean;
    approvedHours: number;
    billedHours: number;
    absenceHours: number;
    overtimeHours: number;
    timeBankBalance?: number;
    compact?: boolean;
}

const GroupEmployeeRow: React.FC<Props> = (props) => {
    const hasClientColumn = props.clientName !== undefined;
    const showPlannedHours = props.showPlannedHours ?? props.plannedHours !== undefined;

    return (<div className={classNames(styles.containerTimeReportGroup, {
        [styles.compact]: props.compact,
        [styles.withGroupClient]: hasClientColumn,
    })}>
        <div className={styles.name}>
            <span className={styles.nameText}>{props.title}</span>
        </div>
        {hasClientColumn && (
            <div className={styles.clientName}>
                <span className={styles.nameText}>{props.clientName}</span>
            </div>
        )}
        <div className={styles.info}>
            <div className={classNames(styles.hours, {
                [styles.withoutPlanned]: !showPlannedHours,
            })}>
                {showPlannedHours && (
                    <div className={classNames(styles.cell, styles.cellRegular)}>{!props.plannedHours ? '' : props.plannedHours}</div>
                )}
                <div className={classNames(styles.cell, styles.cellRegular)}>{props.timeBankBalance === undefined ? '' : props.timeBankBalance}</div>
                <div className={classNames({ [styles.cell]: true, [styles.absence]: true })}>{props.absenceHours === 0 ? '' : props.absenceHours}</div>
                <div className={classNames(styles.cell, styles.cellRegular)}>{props.overtimeHours === 0 ? '' : props.overtimeHours}</div>
                <div className={classNames(styles.cell, styles.cellRegular)}>{props.workHours === 0 ? '' : props.workHours}</div>
                <div className={classNames({
                    [styles.cell]: true,
                    [styles.approved]: true,
                    [styles.isZero]: props.approvedHours === 0
                })}>{props.approvedHours}</div>
                <div className={classNames({
                    [styles.cell]: true,
                    [styles.billed]: true,
                    [styles.isZero]: props.billedHours === 0
                })}>
                    {props.billedHours}</div>
            </div>
        </div>
    </div>)
}

export default GroupEmployeeRow;
